export const WALLBOARD_MANIFEST_PATH = '/v1/wallboards/manifest';
export const WALLBOARD_SESSION_UPGRADE_PATH = '/v1/wallboards/session/upgrade';

// Screenshots render hourly. Poll often enough to pick up a new set promptly.
export const MANIFEST_POLL_MS = 5 * 60 * 1000;
// While the first screenshots are being rendered, or the endpoint is
// unreachable.
export const MANIFEST_RETRY_MS = 60 * 1000;

// Screenshots older than this are flagged on screen.
export const STALE_AFTER_MS = 2 * 60 * 60 * 1000;
